import ReportFolder from 'modules/reports/models/ReportFolder'
import DeleteEndpoint from 'modules/reports/orm/endpoints/DeleteEndpoint'

type DeleteReportFolderRequest = {
  id: number
}

class DeleteReportFolderEndpoint extends DeleteEndpoint<DeleteReportFolderRequest, ReportFolder> {
  model = ReportFolder
  urlParams = ['id']

  buildPath(request: DeleteReportFolderRequest) {
    return `report_folders/${request.id}`
  }
}

export default new DeleteReportFolderEndpoint().fetch
